import {
  CircularProgress,
  Divider,
  Paper,
  Typography,
} from "@material-ui/core";
import { AndroidOutlined, Apple } from "@material-ui/icons";
import { ThemeProvider } from "@material-ui/styles";
import { getTime, InfoWindowProps, useCircularStyles } from ".";
import { MobileApplicationType } from "../../../common/data/service-proxies";
import { getHosTimers } from "../../hos/hosUtils";
import { VehicleStateHeader } from "./VehicleStateHeader";
import { VehicleStatusHeader } from "./VehicleStatusHeader";

export const GoogleMapMarkerInfoWindowContent = ({
  driverFullName,
  dutyStatus,
  drivingSpeed,
  drivingSpeedUnit,
  vehicleName,
  eldConnected,
  geolocation,
  trailers,
  theme,
  translate,
  hosDetails,
  ignitionStatus,
  healthStatus,
  safetyStatus,
  mobileAppType,
  mobileAppVersion,
  isMobile = false,
}: InfoWindowProps) => {
  const classes = useCircularStyles();
  const { cycleWork, shiftDrive, shiftWork } = getHosTimers(hosDetails);

  return (
    <div
      className={`info-window-content ${
        isMobile ? "info-window-content__mobile" : ""
      }`}>
      <ThemeProvider theme={theme}>
        <Paper style={{ backgroundColor: theme.palette.background.paper }}>
          {hosDetails ? (
            <>
              <div className="info-window-content-hos-details">
                <div className="hos-details-wrapper">
                  <CircularProgress
                    variant="determinate"
                    className={classes.bottom}
                    thickness={5}
                    size="4.375rem"
                    value={100}
                  />
                  <CircularProgress
                    variant="determinate"
                    className="hos-details"
                    classes={{
                      circle: classes.circle,
                    }}
                    thickness={5}
                    size="4.375rem"
                    value={(shiftDrive / (hosDetails.maxDrive || 660)) * 100}
                  />
                  <div className="hos-details-label">
                    <Typography variant="body2" component="div">
                      {getTime(shiftDrive)}
                    </Typography>
                    <Typography variant="body2" component="div">
                      Drive
                    </Typography>
                  </div>
                </div>
                <div className="hos-details-wrapper">
                  <CircularProgress
                    variant="determinate"
                    className={classes.bottom}
                    thickness={5}
                    size="4.375rem"
                    value={100}
                  />
                  <CircularProgress
                    variant="determinate"
                    className="hos-details"
                    classes={{
                      circle: classes.circle,
                    }}
                    thickness={5}
                    size="4.375rem"
                    value={(shiftWork / (hosDetails.maxShift || 840)) * 100}
                  />
                  <div className="hos-details-label">
                    <Typography variant="body2" component="div">
                      {getTime(shiftWork)}
                    </Typography>
                    <Typography variant="body2" component="div">
                      Shift
                    </Typography>
                  </div>
                </div>
                <div className="hos-details-wrapper">
                  <CircularProgress
                    variant="determinate"
                    className={classes.bottom}
                    thickness={5}
                    size="4.375rem"
                    value={100}
                  />
                  <CircularProgress
                    variant="determinate"
                    className="hos-details"
                    classes={{
                      circle: classes.circle,
                    }}
                    thickness={5}
                    size="4.375rem"
                    value={(cycleWork / (hosDetails.maxCycle || 4200)) * 100}
                  />
                  <div className="hos-details-label">
                    <Typography variant="body2" component="div">
                      {getTime(cycleWork)}
                    </Typography>
                    <Typography variant="body2" component="div">
                      Cycle
                    </Typography>
                  </div>
                </div>
              </div>
              <Divider />
            </>
          ) : null}
          <VehicleStatusHeader eldConnected={eldConnected} />
          <Divider />
          <VehicleStateHeader
            ignitionStatus={ignitionStatus}
            safetyStatus={safetyStatus}
            healthStatus={healthStatus}
          />
          <Divider />
          <div className="info-window-content-paper">
            <div className="info-window-content-group">
              <div>
                <Typography variant="body2">Vehicle ID</Typography>
              </div>
              <div>
                <Typography variant="body2">{vehicleName}</Typography>
              </div>
            </div>
            <div className="info-window-content-group">
              <div>
                <Typography variant="body2">
                  {translate("resources.locations-current.labels.driverName")}
                </Typography>
              </div>
              <div>
                <Typography variant="body2">{driverFullName}</Typography>
              </div>
            </div>
            <div className="info-window-content-group">
              <div>
                <Typography variant="body2">
                  {translate("resources.locations-current.labels.dutyStatus")}
                </Typography>
              </div>
              <div>
                <Typography variant="body2">
                  {translate(`appData.dutyCycles.${dutyStatus}`)}
                </Typography>
              </div>
            </div>
            <div className="info-window-content-group">
              <div>
                <Typography variant="body2">
                  {translate("resources.locations-current.labels.trailers")}
                </Typography>
              </div>
              <div>
                <Typography variant="body2">
                  {trailers ??
                    translate("resources.locations-current.labels.none")}
                </Typography>
              </div>
            </div>
            <div className="info-window-content-group">
              <div>
                <Typography variant="body2">
                  {translate("resources.locations-current.labels.geolocation")}
                </Typography>
              </div>
              <div>
                <Typography variant="body2">{geolocation ?? "-"}</Typography>
              </div>
            </div>
            <div className="info-window-content-group">
              <div>
                <Typography variant="body2">
                  {translate("resources.locations-current.labels.drivingSpeed")}
                </Typography>
              </div>
              <div>
                <Typography variant="body2">
                  {drivingSpeed ?? "-"} {drivingSpeedUnit}
                </Typography>
              </div>
            </div>
            <div className="mobile-app-container">
              {mobileAppType === MobileApplicationType.Android ? (
                <>
                  <AndroidOutlined fontSize="small" color="disabled" />
                  <Typography variant="caption" color="textSecondary">
                    {` ${mobileAppVersion}`}
                  </Typography>
                </>
              ) : mobileAppType === MobileApplicationType.AppleIos ? (
                <>
                  <Apple fontSize="small" color="disabled" />
                  <Typography variant="caption" color="textSecondary">
                    {` ${mobileAppVersion}`}
                  </Typography>
                </>
              ) : null}
            </div>
          </div>
        </Paper>
      </ThemeProvider>
    </div>
  );
};
